import React from "react"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { library }         from '@fortawesome/fontawesome-svg-core'
import { fas }             from '@fortawesome/free-solid-svg-icons'
import Combobox            from "@shared/combobox"

library.add(fas)

export default function Materials({ quote, replaceQuote }) {
  const selected  = quote.materials || []
  const available = (quote.site.materials || []).filter(
    material => !selected.some(picked => picked.id == material.id)
  )

  const pushMaterial = material => {
    if (!material?.id) return

    replaceQuote({ ...quote, materials: [...selected, material] })
  }

  const popMaterial = material => {
    replaceQuote({ ...quote, materials: selected.filter(picked => picked.id != material.id) })
  }

  if (selected.length == 0 && available.length == 0) return null

  return(
    <div className="form-group">
      <label>{I18n.t("quotes.new.materials")}</label>

      { selected.map(material =>
          <div key={material.id} className="d-flex client-details gap-5">
            <a href    = {material.path}
               target  = "_blank"
               tooltip = {I18n.t("materials.folder")}
            >
              {material.name}
              &nbsp;
              <FontAwesomeIcon icon="external-link-alt"/>
            </a>

            <a onClick={() => popMaterial(material)}>
              <FontAwesomeIcon icon="times" className="txt-blue"/>
            </a>

            <input type="hidden" name="quote[material_ids][]" value={material.id} readOnly />
          </div>
        )
      }

      {/* The whole selection is submitted on save: this blank lets the last one go */}
      <input type="hidden" name="quote[material_ids][]" value="" readOnly />

      { available.length > 0 &&
        <Combobox
          key             = {selected.length}
          value           = ""
          options         = {available}
          onSelectElement = {pushMaterial}
          placeholder     = {I18n.t("workorders.select_material")}
        />
      }
    </div>
  )
}
